module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en_US":{"label":"New password"},"fr_FR":{"label":"Nouveau mot de passe"}}')
  delete Component.options._Ctor
}
